<nb-card size="giant">
    <nb-card-header *ngIf="standAlone">
        <div class="title">{{title}}</div>
    </nb-card-header>
    <ubs-ofbiz-list class="scrollable-container" #myList
        [fieldOptions]="fieldOptions" 
        [listOptions]="listOptions" 
        title="title" 
        [state]="state$" 
        (overViewSelected)="showOverview($event)" 
        [searchResults]="result" 
        (editSelected)="showEditDialog($event)" 
        [columnFields]="columnFields"
        [columnFieldTitles]="columnFieldTitles"
        [remoteFormData]="remoteFormData">
    </ubs-ofbiz-list>
    <!-- <ng-container [ngSwitch]="contentEnum">
        <ng-container *ngSwitchCase="'Gallery'">
            <kve-gallery-editor [product]="product"></kve-gallery-editor>
            
        </ng-container>        
        <ng-container *ngSwitchCase="'Product Identification'">
            <kve-identification-editor></kve-identification-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Standard Features'">
            <kve-features-editor></kve-features-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Selectable Features'">
            <kve-features-editor></kve-features-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Price'">
            <kve-price-editor></kve-price-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Rating'">
            <kve-ratings-editor></kve-ratings-editor>
        </ng-container>
        <ng-container *ngSwitchCase="'Product Packaging'">
            <kve-packaging-editor></kve-packaging-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Short Description'">
            <kve-description-editor></kve-description-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Long Description'">
            <kve-description-editor></kve-description-editor>
        </ng-container> 
        <ng-container *ngSwitchCase="'Product Reviews'">
            <kve-reviews-editor></kve-reviews-editor>
        </ng-container>  
    </ng-container> -->
    
</nb-card>
